import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoFillingInstruction extends Component {

    render() {
        const { fillingInstruction } = this.props;
        const summary = getTitleSummary(fillingInstruction)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Требованиях к описанию отдельных категорий товаров в графе 31'],
                    rows: summary
                }}
                expanded={(fillingInstruction.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Описание',
                        'Примечание',
                        'Режим',
                        'Исключение',
                        'Страна',
                        'Нормативный документ'
                    ],
                    rows: fillingInstruction.map(({
                        to_date = null,
                        description = '',
                        instruction = '',
                        customs_mode = '',
                        except_code = '',
                        country = '',
                        begin_order, begin_order_date, orders_info = null
                    }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        description,
                        instruction,
                        customs_mode,
                        except_code,
                        country,
                        formatOrder(begin_order, begin_order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoFillingInstruction.js